import { combineReducers } from 'redux';

import adminActsReducer from './adminActsReducer';
import adminMailingReducer from './adminMailingReducer';
import adminMessagesReducer from './adminMessagesReducer';
import adminReducer from './adminReducer';
import authReducer from './authReducer';
import configuratorReducer from './configuratorReducer';
import contractReducer from './contractReducer';
import correctionReadyProductsReducer from './correctionReadyProductsReducer';
import correctionSemiProductsReducer from './correctionSemiProductsReducer';
import decisionReducer from './decisionReducer';
import documentsReducer from './documentsReducer';
import fieldsOrderReducer from './fieldsOrderReducer';
import finishedProductReducer from './finishedProductReducer';
import incomingReducer from './incomingReducer';
import infoHistoryReducer from './infoHistoryReducer';
import infoMapReducer from './infoMapReducer';
import inputOperationReducer from './inputOperationReducer';
import inputReadyProductReducer from './inputReadyProductReducer';
import metricReducer from './metricReducer';
import modalErrorReducer from './modalErrorReducer';
import modalReducer from './modalReducer';
import pieceInfoReducer from './pieceInfoReducer';
import popupActReducer from './popupActReducer';
import processingReducer from './processingReducer';
import qrReducer from './qrReducer';
import reportReducer from './reportReducer';
import responsiblePersonReducer from './responsiblePersonReducer';
import savedProductsReducer from './savedProductsReducer';
import semiProductsReducer from './semiProductsReducer';
import settingsLoadingReducer from './settings/loadingReducer';
import settingsReducer from './settingsReducer';
import shipmentReducer from './shipmentReducer';
import soReducer from './soReducer';
import stockConfigureReducer from './stockConfigureReducer';
import stockReducer from './stockReducer';
import supportReducer from './supportReducer';
import surveyReducer from './surveyReducer';
import taskReducer from './taskReducer';
import tabsReducer from './tabsReducer';
import tnReducer from './tnReducer';
import undercutReducer from './undercutReducer';
import userManualReducer from './userManualReducer';
import userReducer from './userReducer';
import wasteReducer from './wasteReducer';
import workingDetailingReducer from './workingDetailingReducer';
import zdvlReducer from './zdvlReducer';

export default combineReducers({
  adminActsReducer,
  adminMailingReducer,
  adminMessagesReducer,
  adminReducer,
  authReducer,
  fieldsOrderReducer,
  configuratorReducer,
  contractReducer,
  correctionReadyProductsReducer,
  correctionSemiProductsReducer,
  decisionReducer,
  documentsReducer,
  finishedProductReducer,
  incomingReducer,
  infoHistoryReducer,
  infoMapReducer,
  inputOperationReducer,
  inputReadyProductReducer,
  metricReducer,
  modalErrorReducer,
  modalReducer,
  pieceInfoReducer,
  popupActReducer,
  processingReducer,
  qrReducer,
  reportReducer,
  responsiblePersonReducer,
  savedProductsReducer,
  semiProductsReducer,
  settingsLoadingReducer,
  settingsReducer,
  shipmentReducer,
  soReducer,
  stockConfigureReducer,
  stockReducer,
  supportReducer,
  surveyReducer,
  tabsReducer,
  taskReducer,
  tnReducer,
  undercutReducer,
  userManualReducer,
  userReducer,
  wasteReducer,
  workingDetailingReducer,
  zdvlReducer
});
